import React from "react";
import { Grid } from "material-ui";
import { Row } from 'react-flexbox-grid';
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import Tooltip from "material-ui/Tooltip";
import { IconButton } from "material-ui";
import { FiInfo } from "react-icons/fi";
import { CardContent } from "material-ui";
import Typography from '@material-ui/core/Typography';
import { AvoidedCO2Text } from "./AvoidedCO2Text";
import { assets } from "../../../assets/";


export class AvoidedCO2Card extends React.Component {

  render() {
    const { 
      classes,
      t, 
      infoButtonHandler,
      avoidedCO2GramsRange,
      avoidedCO2GramsYTD,
      loading,
      user,
      dateRangeText
    } = this.props;

    return (
      <Grid item xs={12} sm={3}>
        <Card className={classes.card} style={{ minHeight: 224 }}>
          <CardHeader
            action={
              <Tooltip title={t("Co2 details")}>
                <IconButton
                  className={classes.button}
                  onClick={() => infoButtonHandler()}
                >
                  <FiInfo
                    style={{
                      color: "rgba(0, 0, 0, 0.54)",
                      fontSize: 16
                    }}
                  />
                </IconButton>
              </Tooltip>
            }
            avatar={<img src={assets.icons.charityIcon} alt="charity_icon" style={{ maxHeight: 20 }} />}
            title={t("Avoided CO2")}
            style={{ paddingBottom: 10, paddingTop: 6 }}
          />
          <CardContent>
            <Grid container spacing={24}>
              <Grid item>
                <Row>
                  <Typography
                    variant="caption"
                    gutterBottom
                    color="textSecondary"
                  >
                    {dateRangeText}
                  </Typography>
                </Row>
                <Row>
                  <AvoidedCO2Text
                    avoidedGrams={avoidedCO2GramsRange}
                    t={t}
                    user={user}
                    classes={classes}
                    loading={loading}
                  ></AvoidedCO2Text>
                </Row>
                <Row style={{marginTop: 8}}>
                  <Typography
                    className={classes.title}
                    variant="caption"
                    gutterBottom
                    color="textSecondary"
                  >
                    {t("Yearly")}
                  </Typography>
                </Row>
                <Row>
                  <AvoidedCO2Text
                    avoidedGrams={avoidedCO2GramsYTD}
                    t={t}
                    user={user}
                    classes={classes}
                    loading={loading}
                  ></AvoidedCO2Text>
                </Row>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/AvoidedCO2/AvoidedCO2Card.js